/**
 * Companies Empty State Component
 *
 * Displayed when no companies are found
 */

import React from 'react';
import { EmptyState } from '@tpct/admin-ui';
import { __ } from '@/hub-shared/utils/i18n';

type CompaniesEmptyStateProps = {
  onRefresh: () => void;
};

const CompaniesEmptyState = ({ onRefresh: _onRefresh }: CompaniesEmptyStateProps) => {
  return (
    <EmptyState
      title={__('Aucune entreprise trouvée')}
      description={__('Commencez par créer votre première entreprise.')}
      className="companies-empty-state"
    />
  );
};

export default CompaniesEmptyState;

